
export type LoadingContext = 
  | 'email-check' 
  | 'database-wakeup' 
  | 'bookings' 
  | 'ai-session' 
  | 'profile' 
  | 'products'
  | 'sound-tracks'
  | 'therapists'
  | 'cart'
  | 'analytics'
  | 'default';

const loadingMessages: Record<LoadingContext, string[]> = {
  'email-check': [
    '🦉 Checking your wellness profile...',
    '🌿 Verifying your account details...',
    '✨ Almost there...'
  ],
  'database-wakeup': [
    '🦉 Waking up our wellness database...',
    '🌅 Stretching and yawning (this takes ~10-15 seconds)...',
    '☕ Brewing some digital tea...',
    '🧘 Taking a deep breath...',
    '🌟 Almost ready for you...'
  ],
  'bookings': [
    '🦉 Fetching your wellness journey...',
    '📅 Loading your peaceful sessions...',
    '🌸 Gathering your appointments...'
  ],
  'ai-session': [
    '🦉 Preparing your AI Experience...',
    '🤖 Warming up the conversation engine...',
    '💭 Getting ready to listen...',
    '✨ Creating your safe space...'
  ],
  'profile': [
    '🦉 Loading your wellness profile...',
    '🌿 Gathering your journey details...',
    '📊 Reviewing your progress...'
  ],
  'products': [
    '🦉 Curating wellness products for you...',
    '🛍️ Finding mindful essentials...',
    '🌟 Loading peaceful offerings...'
  ],
  'sound-tracks': [
    '🦉 Tuning into calming sounds...',
    '🎵 Preparing your audio sanctuary...',
    '🌊 Loading peaceful melodies...'
  ],
  'therapists': [
    '🦉 Finding your perfect guide...',
    '🧘 Loading wellness experts...',
    '💚 Gathering caring professionals...'
  ],
  'cart': [
    '🦉 Reviewing your wellness selections...',
    '🛒 Loading your cart...',
    '✨ Gathering your items...'
  ],
  'analytics': [
    '🦉 Analyzing wellness insights...',
    '📊 Crunching mindful data...',
    '📈 Loading your impact...'
  ],
  'default': [
    '🦉 Taking a mindful moment...',
    '🌿 Loading with care...',
    '✨ Almost there...'
  ]
};

export function getLoadingMessage(context: LoadingContext, attempt: number = 0): string {
  const messages = loadingMessages[context] || loadingMessages.default;
  const index = attempt % messages.length;
  return messages[index];
}

export function getRetryMessage(attempt: number, maxAttempts: number = 5): string {
  if (attempt === 0) return '';
  if (attempt === 1) return 'Connecting...';
  if (attempt >= maxAttempts - 1) return `Final attempt (${attempt}/${maxAttempts})...`;
  return `Retry ${attempt}/${maxAttempts}...`;
}
